import MenuRightSerivce from "@/service/MenuRightService";
import EmployTypeService from "@/service/EmployTypeService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { EmployType } from "@/model/EmployType";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employeeTypeValidationObj from "./S080100-EmployeeTypeValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var employeeTypeDataValidationObj = new employeeTypeValidationObj();
export default {
  name: "employeeType",
  mounted() {
    employeeTypeDataValidationObj.employeeTypeValidation();
    this.assignRights();
    this.resetEmployTypeData();
    this.init();
    this.getAllEmployTypes();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_EmployeeType,
    Settings: Settings,
    dictEnum: dictEnum,
    employType: new EmployType(),
    isEditMode: false,
    employTypeList: [],
    selectAllEmployType: false,
    tempEmployTypeModel: new EmployType(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".emp-table table thead").height();
      var pagginationHeight = $(".paggination-emp").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0  ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllEmployTypes() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await EmployTypeService.getAllEmployTypeByPagination(obj);
      if (response.data.IsSuccess) {
        self.employTypeList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllEmployeeTypeRecord: function () {
      var self = this;
      var IsSelected = self.selectAllEmployType;
      self.employTypeList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleEmployeeTypePopup: function () {
      var arrayList = [];
      var self = this;
      self.employTypeList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteEmployeeType').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleEmployeeType() {
      var arrayList = [];
      var self = this;
      $('#deleteEmployeeType').modal('hide');
      self.employTypeList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        employeeTypeList: arrayList,
      };
      const response = await EmployTypeService.deleteEmployType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetEmployTypeData();
        self.init();
        await self.getAllEmployTypes();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnEmployTypeSelect: function (model) {
      this.tempEmployTypeModel = model;
    },
    addEmployType: function () {
      var self = this;
      $('#employeeTypeModel').modal('show');
      self.isEditMode = false;
      self.employType = new EmployType();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async getEmployTypeDetail() {
      var self = this;
      const obj = {
        empType: self.tempEmployTypeModel.EmpType,
      };
      const response = await EmployTypeService.getEmployTypeDetail(obj);
      if (response.data.IsSuccess) {
        self.employType = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveEmployTypeData(obj) {
      var self = this;
      const response = await EmployTypeService.addEmployType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetEmployTypeData();
        self.init();
        await self.getAllEmployTypes();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditEmployTypeData(obj) {
      var self = this;
      const response = await EmployTypeService.updateEmployType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetEmployTypeData();
        self.init();
        await self.getAllEmployTypes();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveEmployType() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#employeeTypeModel').modal('hide');
          const obj = {
            model: {
              EmpType: self.employType.EmpType,
              CDesc: self.employType.CDesc,
              EDesc: self.employType.EDesc,
              Contract: self.employType.Contract,
              ProbationMth: Number(self.employType.ProbationMth)
            }
          };
          if (self.isEditMode) {
            self.EditEmployTypeData(obj);
          }
          else {
            self.saveEmployTypeData(obj);
          }
        }
      });
    },
    async editEmployType() {
      var self = this;
      self.isEditMode = true;
      if (self.tempEmployTypeModel.EmpType != "") {
        await self.getEmployTypeDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#employeeTypeModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetEmployTypeData: function () {
      var self = this;
      self.selectAllEmployType = false;
      self.isEditMode = false;
      self.employType = new EmployType();
      self.tempEmployTypeModel = new EmployType();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeEmployeeTypePopup: function () {
      var self = this;
      self.selectAllEmployType = false;
      self.isEditMode = false;
      self.employType = new EmployType();
      self.tempEmployTypeModel = new EmployType();
      self.$validator.reset();
      self.vErrors.clear();
      $('#employeeTypeModel').modal('hide');
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1) ;
      this.getAllEmployTypes();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080100-EmployeeType/S080100-EmployeeType.js